import api from '../index';

const baseUrl = '/estimator';

export const createCannedApi = (job) => {
  return api({
    method: 'post',
    url: `${baseUrl}/canned-service`,
    data: job,
  });
};

export const estimatorJobsApi = (job) => {
  return api({
    method: 'post',
    url: `${baseUrl}/job`,
    data: job,
  });
};

export const estimatorApi = (jobs) => {
  return api({
    method: 'post',
    url: `${baseUrl}/create`,
    data: jobs,
  });
};

export const inventoryApi = (job) => {
  return api({
    method: 'post',
    url: `${baseUrl}/add-item-to-inventory`,
    data: job,
  });
};

export const estimatesApi = (query) => {
  return api({
    method: 'get',
    url: `${baseUrl}/list?${query}`,
  });
};

export const estimateApi = (id) => {
  return api({
    method: 'get',
    url: `${baseUrl}/draft/${id}`,
  });
};

export const deleteEstimateApi = (id) => {
  return api({
    method: 'delete',
    url: `${baseUrl}/delete-estimate/${id}`,
  });
};

// nex part api
export const nexPartApi = (data) => {
  return api({
    method: 'post',
    url: `${baseUrl}/next-part`,
    data: data,
  });
};
// partsTech API
export const partsTechApi = (data) => {
  return api({
    method: 'post',
    url: '/partsTech/generate-url',
    data: data,
  });
};

export const convertToRoApi = (payl) => {
  return api({
    method: 'post',
    url: `${baseUrl}/convert`,
    data: payl,
  });
};

export const authorizeApi = (payl) => {
  return api({
    method: 'post',
    url: `${baseUrl}/authorize`,
    data: payl,
  });
};

export const getEstimatedData = (publicKey, authId) => {
  return api({
    method: 'get',
    url: `${baseUrl}/estimate-authorization/${publicKey}/${authId}`,
  });
};

export const updateEstimatedData = (data) => {
  return api({
    method: 'post',
    url: 'estimator/authorize-estimate-jobs',
    data: data,
  });
};

export const createEstimateOnEpicorAPi = (data) => {
  return api({
    method: 'post',
    url: `${baseUrl}/create-estimate-on-epicore`,
    data: data,
  });
};

export const createJobItemsApi = (data) => {
  return api({
    method: 'post',
    url: `${baseUrl}/item/create`,
    data: data,
  });
};

export const createEstimatorApi = (data) => {
  return api({
    method: 'post',
    url: `${baseUrl}/create-estimator`,
    data: data,
  });
};
